<template>
    <div class="sub-account-wrap">
        <div class="container">
            <!-- 顶部快捷栏 -->
            <div class="quick-bar">
                <div class="bar-title">子账号管理</div>
                <div class="btn-group">
                    <el-button type="primary" @click="openAddDialog">新增子账号</el-button>
                    <el-button @click="$router.push('/userInfo')">返回账户信息</el-button>
                </div>
            </div>

            <!-- 权限提示卡片 -->
            <div class="notice-card">
                <span class="dot"></span>
                <span class="text">
                    子账号拥有实际业务操作权限；离职或风险人员请及时禁用账号，避免数据风险。
                </span>
            </div>

            

            <!-- 表格区域 -->
            <div class="table-wrap">
                <el-table :data="UserSubList" border stripe class="sub-table" ref="tableRef"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" align="center" width="55" />
                    <el-table-column label="账号名称" prop="name" align="center" min-width="130" />
                    <el-table-column label="登录账号" prop="mobile" align="center" min-width="140" />
                    <el-table-column label="账号状态" align="center" width="110">
                        <template #default="scope">
                            <el-tag :type="scope.row.iam_static == '1'
                                ? 'success'
                                : 'danger'
                                ">
                                {{
                                    scope.row.iam_static == "1"
                                        ? "正常"
                                        : "异常"
                                }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" prop="create_time" align="center" width="180" />
                    <el-table-column label="最近登录时间" prop="update_time" align="center" width="180">
                        <template #default="scope">
                            {{ scope.row.update_time || "-" }}
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" align="center" width="320">

                    </el-table-column>
                </el-table>
            </div>

            
        </div>

        <!-- 新增/编辑子账号弹窗 -->
        <el-dialog v-model="accountDialogVisible" :title="isEdit ? '编辑子账号' : '新增子账号'" width="520px">
            <el-form :model="form" label-width="110px">
                <el-form-item label="姓名">
                    <el-input v-model="form.name" placeholder="请输入姓名(用作登录)"></el-input>
                </el-form-item>
                <el-form-item label="证件号码" v-if="!isEdit">
                    <el-input v-model="form.cardid" placeholder="请输入证件号码"></el-input>
                </el-form-item>
                <el-form-item label="手机号" v-if="!isEdit">
                    <el-input v-model="form.mobileNo" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" v-if="!isEdit">
                    <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="登录密码" v-if="!isEdit">
                    <el-input v-model="form.password" show-password placeholder="设置初始登录密码"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="accountDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitAccount">新增</el-button>
            </template>
        </el-dialog>

        
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from "vue";
    import { ElMessage, ElMessageBox } from "element-plus";
    import { getUserSubList, createUserSub, updateUserSubStatus } from "@/api/api";



    // import api from '@/api/api'

    const tableRef = ref(null);


    const UserSubList = ref([]);
    const iamStatic = ref("");
    const getAllIamList = async () => {
        const res = await getUserSubList({
            pageNum: page.pageNum,
            pageSize: page.pageSize,
            iam_static: iamStatic.value,
        });
        console.log(res.data.list);
        if (res.code === 200) {
            UserSubList.value = res.data.list;
            page.total = res.data.total;
            page.pageNum = res.data.page;
            page.pageSize = res.data.pageSize;
            page.max = res.data.maxPage;
        }
    };


    // 分页
    const page = reactive({
        pageNum: 1,
        pageSize: 10,
        total: 0,
        max: 100,
    });





    // 弹窗控制
    const accountDialogVisible = ref(false);
    const isEdit = ref(false);
    const currentRow = ref(null);
    const form = reactive({
        name: "",
        cardid: "",
        mobileNo: "",
        email: "",
        password: "",
    });



    // 打开新增
    const openAddDialog = () => {
        isEdit.value = false;
        currentRow.value = null;
        form.name = "";
        form.cardid = "";
        form.mobileNo = "";
        form.email = "";
        form.password = "";
        accountDialogVisible.value = true;
    };



    // 提交新增/编辑
    const submitAccount = async () => {
        if (
            !form.name ||
            !form.password ||
            !form.mobileNo ||
            !form.email ||
            !form.cardid
        ) {
            ElMessage.warning("请完善必填信息");
            return;
        }

        const res = await createUserSub(form);
        if (res.code === 200) {
            ElMessage.success("新增成功");
            console.log(res);
        } else {
            ElMessage.error(res.msg || "新增失败");
        }

        accountDialogVisible.value = false;
        ElMessage.success(isEdit.value ? "编辑成功" : "创建成功");
    };






    onMounted(() => {
        getAllIamList();
    });
</script>

<style lang="scss" scoped>
    .sub-account-wrap {
        width: 100%;
        min-height: 100vh;
        padding: 24px;
        font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
            "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
        background: radial-gradient(1200px 600px at 10% -10%,
                #e8efff 0%,
                transparent 60%),
            radial-gradient(900px 500px at 110% 110%, #f0eaff 0%, transparent 55%),
            linear-gradient(180deg, #f7f9ff 0%, #eef2fb 100%);

        .container {
            max-width: 1400px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            gap: 20px;
        }

        .quick-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #ffffff;
            border-radius: 16px;
            padding: 18px 24px;
            box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04),
                0 12px 32px -12px rgba(16, 24, 40, 0.12),
                0 32px 64px -32px rgba(43, 91, 255, 0.18);

            .bar-title {
                font-size: 20px;
                font-weight: 600;
                color: #111827;
            }

            .btn-group {
                display: flex;
                gap: 12px;
            }
        }

        .notice-card {
            background: #f5f8ff;
            border-radius: 12px;
            padding: 14px 18px;
            display: flex;
            align-items: flex-start;
            gap: 10px;

            .dot {
                width: 6px;
                height: 6px;
                margin-top: 7px;
                border-radius: 50%;
                background: #22c55e;
                box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.18);
                flex-shrink: 0;
            }

            .text {
                font-size: 13px;
                color: #4b5563;
                line-height: 1.6;
            }
        }

        .filter-card {
            background: #ffffff;
            border-radius: 16px;
            padding: 16px 20px;
            box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04),
                0 12px 32px -12px rgba(16, 24, 40, 0.12),
                0 32px 64px -32px rgba(43, 91, 255, 0.18);
        }

        .table-wrap {
            flex: 1;
            background: #fff;
            border-radius: 16px;
            padding: 16px;
            box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04),
                0 12px 32px -12px rgba(16, 24, 40, 0.12),
                0 32px 64px -32px rgba(43, 91, 255, 0.18);
        }

        .page-bar {
            width: 100%;
            height: 48px;
            display: flex;
            padding: 10px 0;
            justify-content: flex-end;
            align-items: center;
        }
    }

    @media (max-width: 720px) {
        .sub-account-wrap {
            padding: 12px;
        }

        .quick-bar {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }
    }
</style>